/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */

/**
 * Email send status
 */
export type SendDocument200Status = typeof SendDocument200Status[keyof typeof SendDocument200Status];


export const SendDocument200Status = {
  sent: 'sent',
  queued: 'queued',
  skipped: 'skipped',
} as const;
